module.exports = __webpack_public_path__ + "img/berlinerkranse_eggs.5709b6e2.jpg";